import React from 'react';
import logo from '../assets/sslogo.jpeg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            {/* <div className="logo">⚡ NexGen</div> */}
            <div className="logo">
            <a href="#home" className="logo"><img src={ logo } alt="Splendid Services Logo" className="logo-img"/></a>
            </div>
            <p>
              Your trusted multi-service business partner delivering
              excellence across event management, corporate solutions,
              technology, and more. Transforming ideas into reality since
              2014.
            </p>
            <div className="contact-social">
              <a href="#!" className="social-link" aria-label="Facebook">
                f
              </a>
              <a href="#!" className="social-link" aria-label="Twitter">
                𝕏
              </a>
              <a href="#!" className="social-link" aria-label="LinkedIn">
                in
              </a>
              <a href="#!" className="social-link" aria-label="Instagram">
                📷
              </a>
            </div>
          </div>

          <div>
            <h4>Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Event Management</a></li>
              <li><a href="#services">Memento & Trophy</a></li>
              <li><a href="#services">Corporate Gifts</a></li>
              <li><a href="#services">Hospitality</a></li>
              <li><a href="#services">Graphic Design</a></li>
            </ul>
          </div>

          <div>
            <h4>More Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Industrial Catering</a></li>
              <li><a href="#services">Business Consulting</a></li>
              <li><a href="#services">Govt. Stationery</a></li>
              <li><a href="#services">Software Development</a></li>
              <li><a href="#services">Facility Services</a></li>
            </ul>
          </div>

          <div>
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#!">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Splendid Services. All rights
            reserved. | Developed By Nabendu Bose (Senior Software Engineer)
          </p>
          <div className="footer-bottom-links">
            <a href="#!">Privacy Policy</a>
            <a href="#!">Terms of Service</a>
            <a href="#!">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;